import httpManager from "@/app/shared/utils/httpManager";
export async function deleteQueue(queueId) {
  const url = `/queues/${queueId}/`;
  const response = await httpManager.delete(url);
  return response?.data;
}
